
(function roleRoleAssociateDocumentTypesControllerDefinition() {
    'use strict';

    angular.module('Role')
        .controller('RoleAssociateDocumentTypesController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend',
            'adminRoleService', 'adminDocumentTypeService', '$filter',
            function roleAssociateFunctionsController($scope, config, $state, $translate, $stateParams, errors,
                adminRoleService, adminDocumentTypeService, $filter) {
                $scope.cancel = function () {
                    $state.go('role-find-preselect', { name: adminRoleService.getFilter().Name });
                };

                $scope.role = {
                    name: $stateParams.name,
                    id: $stateParams.id

                };

                $scope.models = {
                    selected: null,
                    associated: {
                        "title": null,
                        "list": []
                    },
                    availables: {
                        "title": null,
                        "list": []
                    }
                };

                $translate(['RoleAssociateDocumentTypesTitle', 'DocumentTypeAccociatedList', 'DocumentTypeAvailableList']).then(function (translated) {
                    $scope.title = translated.RoleAssociateDocumentTypesTitle;
                    $scope.models.associated.title = translated.DocumentTypeAccociatedList;
                    $scope.models.availables.title = translated.DocumentTypeAvailableList;
                });

                $scope.moveItemFromAssociated = function (item, index) {
                    $scope.models.associated.list.splice(index, 1);
                    $scope.models.availables.list.push(item);
                }

                $scope.moveItemFromAvailables = function (item, index) {
                    $scope.models.availables.list.splice(index, 1);
                    $scope.models.associated.list.push(item);
                }

                adminDocumentTypeService.getRoleDocumentTypes($stateParams.id).then(function (documentTypes) {
                    $scope.models.associated.list = documentTypes;
                }, function (error) {
                    errors.showError(error);
                    $scope.cancel();
                }).then(function () {
                    adminDocumentTypeService.getNotInRole($stateParams.id).then(function (result) {
                        $scope.models.availables.list = result;
                    });
                });

                $scope.save = function () {
                    var resultList = [];
                    $scope.models.associated.list.forEach(function (dt) {
                        if (dt.roles && dt.roles.metadatas && dt.roles.metadatas.length > 0) {
                            dt.metadatas = dt.roles.metadatas;
                        }
                    });

                    return adminDocumentTypeService.setRoleDocumentTypes($stateParams.id, $scope.models.associated.list).then(function () {
                        $state.go('role-container-types', { id: $stateParams.id, name: $stateParams.name });
                    },
                        function (error) {
                            errors.showError(error);
                        });
                };
            }
        ]);
})();